import { apiClient } from '@/shared/api/client';
import type { ApiResponse } from '@/shared/types/api.types';
import { malaysiaScraping, type SsmLoginResponse } from './malaysiaScraping';
import type { ChangeAddressPayload } from '../components/change-address/composables/useFormPayload';

// Re-export for convenience
export type { SsmLoginResponse };
export type { ChangeAddressPayload };

/**
 * Change Address API
 * Malaysia 등록주소 변경 전용 API
 *
 * Endpoint: /api/marketplace/v1/malaysia/entity/change-address
 */

/**
 * Change Address 응답 타입
 */
export interface ChangeAddressResponse {
  success: boolean;
  error?: string;
  html?: string;
  pdfDataBase64?: string;
  pdf_data_base64?: string;
  warning?: string;
}

/**
 * Change Address API
 */
export const changeAddressApi = {
  /**
   * SSM 로그인 (공통 API 재사용)
   */
  ssmLogin: (credentialId: string): Promise<SsmLoginResponse> => {
    return malaysiaScraping.ssmLogin(credentialId, 'mycoid2016');
  },

  /**
   * SSM 로그아웃
   */
  ssmLogout: (sessionId: string) => {
    return malaysiaScraping.ssmLogout(sessionId);
  },

  /**
   * Change Address 실행
   */
  changeAddress: async (data: ChangeAddressPayload): Promise<ApiResponse<ChangeAddressResponse>> => {
    console.log('[ChangeAddressApi] Request:', {
      unique_entity_number: data.unique_entity_number,
      firm_name: data.firm_name,
      state: data.state,
      city: data.city,
    });

    const response = await apiClient.post<ChangeAddressResponse>(
      '/marketplace/v1/malaysia/entity/change-address',
      data
    );

    console.log('[ChangeAddressApi] Response:', {
      success: (response as any)?.success || (response as any)?.data?.success
    });

    return response;
  },
};

export default changeAddressApi;
